// Servicio de settings públicos/admin

import HttpClient from './HttpClient'
import {
  GRADUATION_REQUIREMENTS_DEFAULTS,
  pickGraduationFromSettings,
} from '../utils/graduationRequirements'

const DEFAULT_WIZARD_PATH = {
  wizard_path_estudiante_title: 'Estudiante de academia',
  wizard_path_estudiante_body:
    'Tutorial guiado. Ficha más corta. Escenas seguras. Empiezas en nivel 1; del 1 al 10 cada nivel cuesta 1 de experiencia. Ideal si eres nuevo en el foro o en el rol.',
  wizard_path_shinobi_title: 'Shinobi',
  wizard_path_shinobi_body:
    'Entras al juego completo. Ficha entera revisada por el staff. Empiezas en nivel 10. Más libertad y más exigencia narrativa desde el día uno.',
}

function pickWizardPath(data = {}) {
  return {
    wizard_path_estudiante_title:
      String(data.wizard_path_estudiante_title || '').trim() || DEFAULT_WIZARD_PATH.wizard_path_estudiante_title,
    wizard_path_estudiante_body:
      String(data.wizard_path_estudiante_body || '').trim() || DEFAULT_WIZARD_PATH.wizard_path_estudiante_body,
    wizard_path_shinobi_title:
      String(data.wizard_path_shinobi_title || '').trim() || DEFAULT_WIZARD_PATH.wizard_path_shinobi_title,
    wizard_path_shinobi_body:
      String(data.wizard_path_shinobi_body || '').trim() || DEFAULT_WIZARD_PATH.wizard_path_shinobi_body,
  }
}

function pickGraduation(data = {}) {
  const normalized = pickGraduationFromSettings(data)
  return {
    graduation_intro: normalized.intro,
    graduation_items: normalized.items,
  }
}

function mapPublicOrAdmin(data) {
  return {
    enable_empires: !!(data && data.enable_empires),
    background_map_url: data?.background_map_url ?? null,
    background_map_opacity: Number.isFinite(Number(data?.background_map_opacity))
      ? Number(data.background_map_opacity)
      : 0.9,
    background_map_min_width: Number.isFinite(Number(data?.background_map_min_width))
      ? Number(data.background_map_min_width)
      : 1000,
    background_map_min_height: Number.isFinite(Number(data?.background_map_min_height))
      ? Number(data.background_map_min_height)
      : 1000,
    ...pickWizardPath(data),
    ...pickGraduation(data),
  }
}

// GET /api/v1/public/settings
export async function fetchPublicSettings(signal) {
  const { data } = await HttpClient().get('/api/v1/public/settings', signal ? { signal } : undefined)
  return {
    ...mapPublicOrAdmin(data),
    coming_soon_enabled: !!(data && data.coming_soon_enabled),
  }
}

// Admin: GET /api/v1/admin/settings
export async function fetchAdminSettings() {
  const { data } = await HttpClient().get('/api/v1/admin/settings')
  return {
    id: 'app',
    ...mapPublicOrAdmin(data),
  }
}

// Admin: PATCH /api/v1/admin/settings
export async function patchAdminSettings(payload = {}) {
  const body = {}
  if (typeof payload.enable_empires !== 'undefined') {
    body.enable_empires = !!payload.enable_empires
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'background_map_url')) {
    body.background_map_url = payload.background_map_url ?? ''
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'background_map_opacity')) {
    body.background_map_opacity = Number(payload.background_map_opacity)
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'background_map_min_width')) {
    body.background_map_min_width = Number(payload.background_map_min_width)
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'background_map_min_height')) {
    body.background_map_min_height = Number(payload.background_map_min_height)
  }
  for (const key of Object.keys(DEFAULT_WIZARD_PATH)) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      body[key] = payload[key] ?? ''
    }
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'graduation_intro')) {
    body.graduation_intro = payload.graduation_intro ?? ''
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'graduation_items')) {
    body.graduation_items = Array.isArray(payload.graduation_items) ? payload.graduation_items : []
  }
  const { data } = await HttpClient().patch('/api/v1/admin/settings', body)
  return {
    id: 'app',
    ...mapPublicOrAdmin(data),
  }
}

export { DEFAULT_WIZARD_PATH, GRADUATION_REQUIREMENTS_DEFAULTS }

export default {
  fetchPublicSettings,
  fetchAdminSettings,
  patchAdminSettings,
}
